'use client'

import SleepTile from '@/components/SleepTile'
import InspirationTile from '@/components/InspirationTile'
import SteveTile from '@/components/SteveTile'
import ClosetTile from '@/components/ClosetTile'
import FantasyTile from '@/components/FantasyTile'
import RotationTile from '@/components/RotationTile'
import MacTile from '@/components/MacTile'
import { createTrackedTile } from '@/components/createTrackedTile'

export const SleepTileTracked = createTrackedTile(SleepTile, 'sleep')
export const InspirationTileTracked = createTrackedTile(
  InspirationTile,
  'inspiration',
)
export const SteveTileTracked = createTrackedTile(SteveTile, 'steve')
export const ClosetTileTracked = createTrackedTile(ClosetTile, 'closet')
export const FantasyTileTracked = createTrackedTile(FantasyTile, 'fantasy')
export const MacTileTracked = createTrackedTile(MacTile, 'mac')

export const RotationTileTracked = createTrackedTile(RotationTile, 'rotation')

import MuseumTile from '@/components/MuseumTile'
export const MuseumTileTracked = createTrackedTile(MuseumTile, 'museum')

import BricksTile from '@/components/BricksTile'
export const BricksTileTracked = createTrackedTile(BricksTile, 'bricks')
